<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="table-container">
      <div class="table-title">
        <div class="table-caption">
          当社の安全に対する姿勢
        </div>
        輸送の安全に関する
        基本的な指針
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              ①社長は、輸送の安全の確保が根幹であることを深く認識し、
                社員に輸送の安全の確保が最も重要であるという意識を徹底させ、
                また、社内において輸送の安全の確保に主導的な役割を果たす。
              ②安全マネジメントを確実に実施し、全社員が一丸となって業務を遂行することにより、
                絶えず輸送の安全性の向上に努める。
              ③輸送の安全に関する情報について、積極的に公表する。
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          安全に関する認証
        </div>
        日本バス協会認定
        「貸切バス事業者安全性評価認認定制度」
        （<a href="https://www.mlit.go.jp/jidosha/jidosha_tk3_000043.html">セーフティバス</a>） 最高ランクの★★★★取得
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              この制度は貸切バス事業者の安全性や安全の確保に向けた取り組み状況について評価認定を行う制度で、平成23年度（2011）から開始されました。当社では平成23年（初年度）に認定を受け、同制度最高の3つ星を業界第1グループとして取得しました。2021年度には<a href="https://www.bus.or.jp/safety/pdf/20211227_nintei_awards.pdf">10年連続セーフティバス取得事業者</a>として表彰されました(表彰事業者120社(当時))。貸切バス会社全国3,377社のうちセーフティバス認定事業者は1,969社(58.3%)、その中で最高ランクの★★★★は42社(1.2%)です。(2025年度認定時(2025.12.21))
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          安全に関する認証
        </div>
        公益社団法人全日本トラック協会
        「貨物自動車運送事業者安全性優良事業所認定」（<a href="https://www.mlit.go.jp/jidosha/jidosha_tk4_000013.html">Gマーク</a>）取得
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              この制度は国土交通大臣指定機関が法に規定する輸送の安全確保等に関する事項について充分に評価した事業所に認定するもので、同一法人であっても各事業所(営業所)毎に認定されます。 認定事業所は貨物運送事業社全国約84,954事業所のうち、29,210事業所(34.4%)です。 認定事業者数は全事業者62,383事業者のうち13,391社(21.5%)です。(2025年度認定時(2025.12.16))
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          過去20年以上の事故に関する統計
        </div>
        過去20年以上、事故件数は0件。（自動車事故報告規則第二条に基づく）
        引き続き当社は安全を追求します。
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              令和07年7月～令和08年6月（当社令和07年度） ０件
              令和06年7月～令和07年6月（当社令和06年度） ０件
              令和05年7月～令和06年6月（当社令和05年度） ０件
              令和04年7月～令和05年6月（当社令和04年度） ０件
              令和03年7月～令和04年6月（当社令和03年度） ０件
              令和02年7月～令和03年6月（当社令和02年度） ０件
              令和01年7月～令和02年6月（当社令和01年度） ０件
              平成30年7月～令和01年6月（当社平成30年度） ０件
              平成29年7月～平成30年6月（当社平成29年度） ０件
              平成28年7月～平成29年6月（当社平成28年度） ０件
              平成27年7月～平成28年6月（当社平成27年度） ０件
              平成26年7月～平成27年6月（当社平成26年度） ０件
              平成25年7月～平成26年6月（当社平成25年度） ０件
              平成24年7月～平成25年6月（当社平成24年度） ０件
              平成23年7月～平成24年6月（当社平成23年度） ０件
              平成22年7月～平成23年6月（当社平成22年度） ０件
              平成21年7月～平成22年6月（当社平成21年度） ０件
              平成20年7月～平成21年6月（当社平成20年度） ０件
              平成19年7月～平成20年6月（当社平成19年度） ０件
              平成18年7月～平成19年6月（当社平成18年度） ０件
              平成17年7月～平成18年6月（当社平成17年度） ０件
              平成16年7月～平成17年6月（当社平成16年度） ０件
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title">令和8年度の目標（令和8年7月~令和9年6月）</div>
      <table class="table">
        <tbody>
          <tr v-for="(goals, index) in goals" :key=index>
            <th>{{ goals.title }}</th>
            <td>{{ goals.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container last">
      <div class="table-title">令和7年度の目標達成結果（令和7年7月~令和8年6月）</div>
      <table class="table">
        <tbody>
          <tr v-for="(results, index) in results" :key=index>
            <th>{{ results.title }}</th>
            <td>{{ results.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'SAFETY',
      message: '世界一安全に大型輸送を行うために',
      goals: [
        { title: '（1）事故件数（自動車事故報告規則第2条に基づく事故）', content: '人身事故 / 物損事故 / 車両故障　0件' },
        { title: '（2）自動点呼の実施', content: '貨物：100％\n旅客：業務終了点呼100％' },
        { title: '（3）運転士の業務負担を軽減し、安全運転に注力させる', content: '全車新型デジタコに換装し、運転者の日報記入等の負担を大幅に軽減する' },
        { title: '（4）安全性に関する認定の更新', content: '貨物：Gマーク(土浦営業所)' },
        { title: '（5）実車運転による技能訓練、実地訓練、ASV搭載車両訓練を実施する', content: '実際の運行での感じた危険箇所の実地訓練や車庫内での狭路走行訓練などの実車走行訓練、ASV搭載車両での稼働走行訓練など' },
        { title: '（6）適切な車両点検の実施による車両故障の撲滅', content: '旅客：車両導入後7年でオーバーホールを行う' }],
      results: [
        { title: '（1）事故件数（自動車事故報告規則第2条に基づく事故）', content: '人身事故 / 物損事故 / 車両故障　0件（目標達成）' },
        { title: '（2）自動ブレーキまたは衝突警報＋車線逸脱警報装置装着比率', content: '貨物：100％（目標達成）\n旅客：全車両に取付済' },
        { title: '（3）安全性に関する認定の更新', content: '貨物：Gマーク(さいたま第一営業所)（目標達成）\n旅客：セーフティバス　4つ星（目標達成）' },
        { title: '（4）運転士の業務負担を軽減し、安全運転に注力させる', content: '旅客：全車両のチェーンを最新の軽量チェーンに切り替え済(目標達成)' },
        { title: '（5）実車運転による技能訓練、実地訓練、ASV搭載車両訓練を実施する', content: '緊急時のブレーキ操作訓練(8月)、雪道走行訓練(12月富士見高原、1月たかつえ・水上)、火災発生時の対応訓練(3月)などを実施し、運転技術向上に努めました。' },
        { title: '（6）適切な車両点検の実施による車両故障の撲滅', content: '旅客：車内点検において、7年でのオーバーホール実施を決定、実施中' }]
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/safety.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  width: 40%;
  color: #000000;
}
.table th {
  color: #707F89;
}
.text {
  font-size: 20px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Safety.vue